import { Loader } from '@loomhq/lens';
import classNames from 'classnames';
import React, { Component } from 'react';

import './styles.less';

export default class Button extends Component {
  render() {
    const {
      buttonClass,
      buttonType,
      onClicked,
      capitalize = true,
      className = 'button',
      disabled,
      loading,
      style,
      value,
      outerClass,
    } = this.props;

    const buttonClassValue = buttonClass ? buttonClass : '';

    // loading takes precedence

    const buttonDisabled = disabled && !loading ? 'disabled' : '';
    const buttonLoading = loading ? 'loading' : '';
    const buttonValueCapitalize = capitalize ? 'capitalize' : '';

    const buttonComputedClass = [
      className,
      buttonType,
      buttonClassValue,
      buttonDisabled,
      buttonLoading,
      buttonValueCapitalize,
    ].join(' ');

    const wrapperClass = classNames('loom-button', outerClass);

    return (
      <div className={wrapperClass}>
        {loading && (
          <div id="button-loading-indicator">
            <Loader color="white" />
          </div>
        )}
        <input
          type="button"
          className={buttonComputedClass}
          style={style}
          disabled={disabled}
          onClick={onClicked}
          value={value}
        />
      </div>
    );
  }
}
